var BrevoFormCaptcha = /** @class */ (function () {
    function BrevoFormCaptcha() {
        var forms = document.querySelectorAll('form.sib_signup_form');
        forms.forEach(function (form) {
            new Form(form);
        });
    }
    return BrevoFormCaptcha;
}());
var Form = /** @class */ (function () {
    function Form(form) {
        this.validatedCaptcha = false;
        this.form = form;
        this.button = form.querySelector('button[type="submit"]');
        form.addEventListener('submit', this.onSubmit.bind(this), true);
        this.button.addEventListener('click', this.onSubmit.bind(this), true);
    }
    Form.prototype.onSubmit = function (event) {
        // if (!this.validatedCaptcha) {
        // 	event.preventDefault();
        // 	event.stopPropagation();
        // 	this.form.classList.add('sib_processing');
        // 	const data: { [key: string]: unknown } = {};
        // 	const formData = new FormData(this.form);
        // 	formData.forEach((value, key) => {
        // 		// Remove sib form action to prevent sendinblue plugin from handling this post request
        // 		if (!key.includes('sib_form_action')) {
        // 			data[key] = value;
        // 		}
        // 	});
        // 	Captcha.submit('submit', data)
        // 		.then(() => {
        // 			this.validatedCaptcha = true;
        // 			const validatedCaptchaInput = document.createElement('input');
        // 			validatedCaptchaInput.type = 'hidden';
        // 			validatedCaptchaInput.name = 'recaptcha-validated';
        // 			validatedCaptchaInput.value = '1';
        // 			this.form.appendChild(validatedCaptchaInput);
        // 			this.form.classList.remove('sib_processing');
        // 			setTimeout(() => this.button.click(), 0);
        // 		})
        // 		.catch(() => {
        // 			this.validatedCaptcha = false;
        // 			this.form.classList.remove('sib_processing');
        // 		});
        // }
    };
    return Form;
}());
export { BrevoFormCaptcha };
